/* eslint-disable import/prefer-default-export */
import axios from 'axios';
import { getUserSummaryConfig } from '../../../../config/apiConfig';

export const getActivitiesAndTaskConfigurations = async () => {
  // Get auth header config
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v1/adminconfiguration`;
  return axios
    .get(requestUrl, config)
    .then(async (response) => {
      return response.data;
    })
    .catch(() => {
      return null;
    });
};

export const saveActivitiesAndTaskConfigurations = async (data) => {
  // post auth header config
  const config = await getUserSummaryConfig();
  const requestUrl = `api/v1/saveadminconfiguration`;
  return axios
    .post(requestUrl, data, config)
    .then(async (response) => {
      return response;
    })
    .catch(() => {
      return null;
    });
};
